import { MonthlySubscription, YearlySubscription } from '../../../utils/content';
import PricingCard from '../Components/PricingCard';

export default function PricingPage({handlePlanChange}) {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl sm:text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Compare plans</h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Distinctio et nulla eum soluta et neque labore quibusdam. Saepe et quasi iusto modi velit ut non voluptas
            in. Explicabo id ut laborum.
          </p>
        </div>
        <PricingCard handlePlanChange={handlePlanChange} {...MonthlySubscription} />
        <PricingCard handlePlanChange={handlePlanChange} {...YearlySubscription} />
      </div>
    </div>
  )
}
